export default defineNuxtRouteMiddleware((_, from) => {
  const { setUrlFrom } = useHeaderNavigation()
  if (from?.fullPath) setUrlFrom(from.fullPath)
})
